// extracted by mini-css-extract-plugin
module.exports = {"emailTemplatePreview":"EmailTemplatePreview_emailTemplatePreview__2H7u8"};